import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { getOtherOptionsFromWindow } from "../../../utils";
import { getUserDecision } from "../../getUserDecision";
import { isCrawler } from "../../../utils/isCrawler";
/**
 * Is the current request from a spider / crawler?
 */

var preDecisionGatewayIsCrawler = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _getOtherOptionsFromW, isAcceptAllForBots;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getOtherOptionsFromW = getOtherOptionsFromWindow(), isAcceptAllForBots = _getOtherOptionsFromW.isAcceptAllForBots;

            if (!(getUserDecision() !== false || !isAcceptAllForBots)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", false);

          case 3:
            return _context.abrupt("return", isCrawler() ? "all" : false);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function preDecisionGatewayIsCrawler() {
    return _ref.apply(this, arguments);
  };
}();

export { preDecisionGatewayIsCrawler };